module.exports = __webpack_public_path__ + "static/media/logo.ac95714d.png";